require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-adriana-pou.json") })
        }
      }, "path---en-us-team-adriana-pou");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-adriana-pou!./.cache/json/en-us-team-adriana-pou.json
// module id = 585
// module chunks = 231608221292675